export default function Footer() {
  const footerLinks = {
    platform: [
      { name: 'List Your Item', href: '#' },
      { name: 'Browse Items', href: '#' },
      { name: 'How It Works', href: '#how-it-works' }
    ],
    community: [
      { name: 'Success Stories', href: '#' },
      { name: 'Trust & Safety', href: '#' },
      { name: 'Impact Report', href: '#' }
    ],
    support: [
      { name: 'Help Center', href: '#' },
      { name: 'Contact Us', href: '#contact' },
      { name: 'Report Issue', href: '#' }
    ],
    company: [
      { name: 'About Us', href: '#' },
      { name: 'Careers', href: '#' },
      { name: 'Press Kit', href: '#' }
    ]
  };

  const socialLinks = [
    { icon: 'ri-facebook-fill', href: '#' },
    { icon: 'ri-instagram-line', href: '#' },
    { icon: 'ri-twitter-x-line', href: '#' },
    { icon: 'ri-linkedin-fill', href: '#' }
  ];

  return (
    <footer id="contact" className="bg-gradient-to-br from-teal-700 via-teal-600 to-emerald-700 text-white relative overflow-hidden">
      <div className="absolute inset-0 opacity-5">
        <svg className="w-full h-full" viewBox="0 0 1200 600">
          <path d="M0,300 Q300,200 600,300 T1200,300" stroke="white" strokeWidth="2" fill="none" opacity="0.3"/>
          <path d="M0,350 Q300,250 600,350 T1200,350" stroke="white" strokeWidth="2" fill="none" opacity="0.2"/>
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-16 relative z-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 mb-12">
          <div className="lg:col-span-4">
            <div className="flex items-center gap-2 mb-6">
              <img 
                src="https://static.readdy.ai/image/4ec7ec27730ecfd7806b39abe8d65555/3475e3a588418a365d8e7a1b91dd7559.jpeg" 
                alt="Kozda SwapDeal Logo" 
                className="h-10 w-10 object-contain"
              />
              <span className="text-2xl font-bold">Kozda SwapDeal</span>
            </div>

            <div className="mb-6">
              <div className="flex gap-2">
                <input
                  type="email"
                  placeholder="Enter your email"
                  className="flex-1 px-4 py-3 rounded-full bg-white/10 border border-white/20 text-white placeholder-white/60 focus:outline-none focus:border-white/40 text-sm"
                />
                <button className="w-12 h-12 bg-white/20 hover:bg-white/30 rounded-full flex items-center justify-center transition-colors flex-shrink-0 cursor-pointer">
                  <i className="ri-notification-line text-white text-lg"></i>
                </button>
              </div>
            </div>

            <div className="text-3xl font-serif leading-tight">
              Less Waste.<br />
              More Value.
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
              <div>
                <h3 className="font-bold text-lg mb-4">Platform</h3>
                <ul className="space-y-3">
                  {footerLinks.platform.map((link, index) => (
                    <li key={index}>
                      <a href={link.href} className="text-white/80 hover:text-white transition-colors text-sm whitespace-nowrap">
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h3 className="font-bold text-lg mb-4">Community</h3>
                <ul className="space-y-3">
                  {footerLinks.community.map((link, index) => (
                    <li key={index}>
                      <a href={link.href} className="text-white/80 hover:text-white transition-colors text-sm whitespace-nowrap">
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h3 className="font-bold text-lg mb-4">Support</h3>
                <ul className="space-y-3">
                  {footerLinks.support.map((link, index) => (
                    <li key={index}>
                      <a href={link.href} className="text-white/80 hover:text-white transition-colors text-sm whitespace-nowrap">
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div>
                <h3 className="font-bold text-lg mb-4">Company</h3>
                <ul className="space-y-3">
                  {footerLinks.company.map((link, index) => (
                    <li key={index}>
                      <a href={link.href} className="text-white/80 hover:text-white transition-colors text-sm whitespace-nowrap">
                        {link.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20 pt-8">
          <div className="flex flex-col md:flex-row items-center justify-between gap-6">
            <div className="text-sm text-white/70">
              © 2025 Kozda SwapDeal. All rights reserved.
            </div>

            <div className="flex items-center gap-4">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.href}
                  className="w-10 h-10 border border-white/30 rounded-lg flex items-center justify-center hover:bg-white/10 transition-colors cursor-pointer"
                >
                  <i className={`${social.icon} text-lg`}></i>
                </a>
              ))}
            </div>

            <div className="flex items-center gap-6 text-sm">
              <a href="#" className="text-white/70 hover:text-white transition-colors whitespace-nowrap">
                Privacy Policy
              </a>
              <a href="#" className="text-white/70 hover:text-white transition-colors whitespace-nowrap">
                Terms of Service
              </a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="text-white/70 hover:text-white transition-colors whitespace-nowrap">
                Powered by Readdy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
